<template>
    <div class="popupBg" @click.self="pressCancel">
        <div class="popupArea bg-lightest px-3">

            <div class="text-center fs-larger font-weight-600 p-3">
                Payments
            </div>

            <div class="col-sm-12 paymentRowsHolder">
                <div class="d-flex flex-row justify-content-between" v-for="payment in paymentsList">
                    <span class="font-weight-600">
                        <span>{{formatDateForList(payment.date)}}</span>
                        <span class="dark">{{composePaymentDetailsRow(payment)}}</span>
                    </span>
                    <span class="font-weight-600" :class="{'color-3': payment.paymentDirection==0, 'color-6': payment.paymentDirection==1}">
                        <span class="mr-2">{{payment.paymentDirection==0? '':'-'}}</span>
                        <span>{{formatPrice(payment.value) + ' ' + payment.currency }}</span>
                    </span>
                </div>
            </div>

            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-6" v-for="paymentDirection in getPaymentDirections">
                        <button class="btn widest w-100" :class="{'opacity-30':payment.paymentDirection != null && payment.paymentDirection != paymentDirection.id, 'action': paymentDirection.id == 1}" @click="showPaymentArea(paymentDirection.id)">{{paymentDirection.description}}</button>
                    </div>
                </div>
            </div>

            <div class="col-sm-12 d-flex align-items-end mb-2 justify-content-end">
                <div v-if="reservation.status == '-5'">
                    <label class="mr-3">
                        Amount to refund
                    </label>
                    <span class="fs-large font-weight-600" :class="{'color-6': refundTotalMissing < 0, 'color-3': refundTotalMissing === 0 }">{{ formatPrice(refundTotalMissing) }} €</span>
                </div>

                <div v-if="reservation.status != '-5'">
                    <label class="mr-3">
                        <span v-if="totalDue >= 0">Due to Pay</span>
                        <span v-if="totalDue < 0">Over Pay</span>
                    </label>
                    
                    <span class="fs-large font-weight-600" :class="{'color-6': totalDue < 0 }">{{ formatPrice(totalDue) }} €</span>

                    <label class="mx-3">
                        Total
                    </label>
                    <span class="fs-large font-weight-600">{{ formatPrice(getReservationCalculations.grandTotal) }} €</span>
                </div>
            </div>

            <div v-if="showPayArea" class="mt-3">
                <div class="col-sm-12 d-flex flex-row justify-content-between">
                    <label>Select payment method</label>
                    <label>Amount</label>
                </div>

                <div class="col-sm-12 mt-3 pb-3">
                    <div class="row">
                        <div class="col-sm-9 d-flex flex-row align-items-center flex-wrap">
                            <payment-method-picker v-model="payment.type" />
                        </div>

                        <div class="col-sm-3 d-flex align-items-start">
                            <div class="d-flex flex-row align-items-center">
                                <span class="color-6 fs-super mr-2" v-if="payment.paymentDirection == 1">-</span>
                                <input type="number" style="height: 50px;" step=".01" min="0" class="fs-largest w-100 text-right bg-lighter glued-right overflow-auto" v-model.number="payment.value" placeholder="0">
                                <div class="border-light glued-left fs-largest py-2 px-2">€</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-12 row mx-0 px-0 pb-3 border-top-light pt-3">
                    <div class="col-sm-12 d-flex align-items-center">
                        <label class="mr-2">
                            Notes
                        </label>
                        <input type="text" class="w-100" v-model="payment.description">
                    </div>
                </div>

                <div class="col-sm-12 my-2 text-right">
                    <button class="btn tertiary wider" :disabled="isSavingPayment" @click="pressCancel">Cancel</button>
                    <button class="btn primary wider ml-2" :disabled="isSavingPayment" @click="savePayment">Done</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { reservationsMixin } from '@/mixins/reservations'

import extendedVSelect from '@/extends/vue-select'
import paymentMethodPicker from '@/tools/PaymentMethodPicker'

export default {
    data() {
        return {
            showPayArea: false,
            payment: {
                type: 1,
                value: null,
                currency: "€",
                paymentDirection: null,
                treasurerUserAccount: null, // We can save the treasurer as an agent or supplier or user account
                description: ''
            },
            description: null,
            tempBilling: {
                promoCode: "",
                promoCodeDiscountType: null,
                promoCodeDiscountCode: null,
                discountType: 0,
                discountValue: 0,
                description: "",
                details: {
                    vat: "",
                    businessName: "",
                    address: "",
                    city: "",
                    country: 1
                },
                invoices: null,
                payments: [
                    {
                        type: {
                            id: 1,
                            description: "Cash"
                        },
                        value: null,
                        currency: "€"
                    }
                ]
            },
            tresurerArr:[],
            selectedTresurer: null,
            showBillingDetails: false,
            showNotes: false,
            myTeamMembers: [],
            isSavingPayment: false
        }
    },
    props:{
        reservation: {
            type: Object
        },
        showAddPayment: {
            type: Boolean
        }
    },
    created() {
        // Set tresurer as me
        this.selectedTresurer = this.tresurerMe;

        // If reservation is canceled the amount to refund will show pre-populated
        if (this.reservation.status == '-5') {
            this.showPaymentArea(1);
            this.payment.value = this.refundTotalMissing;
        }

        this.treasurerChanged();
    },
    mixins:[
        reservationsMixin
    ],
    computed: {
        ...mapGetters([
            'getReservation',
            'account',
            'getPaymentDirections',
            'getReservationCalculations',
            'getAgents',
            'getPaymentTypeListAll',
            'getCountries'
        ]),
        totalDue(){
            return this.getReservationCalculations.totalInDue;
        },
        paymentsList() {
            return this.reservation.payments.sort(function(a, b) {
                return a.id - b.id;
            });
        },
        totalInPyamentOptions() {
            let total = 0;

            for(let paymentOption of this.tempBilling.payments){
                total += Number(paymentOption.value);
            }

            return total;
        },
        outstandingAmout() {
            return this.reservationTotalCost.withDiscount.withVat - this.totalInPyamentOptions;
        },
        editedTresurerList() {
            let tresurerList = JSON.parse(JSON.stringify(this.tresurerArr));
            tresurerList.unshift(this.tresurerMe);

            return tresurerList;
        },
        tresurerMe() {
            return {name: this.account.name + ' (Me)', id: this.account.id};
        },
        refundTotalMissing() {
            return this.getReservationCalculations.totalInDue;
        }
    },
    methods: {
        ...mapActions(),
        cancel() {
            this.close();
        },
        removePaymentOption(index) {
            this.tempBilling.payments.splice(index, 1);
        },
        selectPayMethod(paymentMethod) {
            this.payment.type = paymentMethod.id;
        },
        savePayment() {
            if (this.payment.value != null && this.payment.value > 0) {
                this.payment.date = moment().format("YYYY-MM-DD hh:mm:00");

                // Add row to billing payemnts list to help with calculations
                this.reservation.payments.push(this.payment);
                this.$emit('toggleAddPayment');
            } else {
                this.$emit('toggleAddPayment');
            }
        },
        pressCancel() {
            this.$emit('toggleAddPayment');
        },
        showPaymentArea(direction) {
            this.payment.paymentDirection = direction;
            this.showPayArea = true;
        },
        formatDateForList(dateTime) {
            return this.formatDateDots(dateTime)+' '+this.formatTime(dateTime);
        },
        payMethodIdToName(payMethodId) {
            var output = this.getPaymentTypeListAll.filter(payMethod => {
                return payMethod.id ==  payMethodId;
            })

            if (output && output.length > 0) {
                return output[0].description;
            } else {
                return null;
            }
        },
        getMyTeamMembers() {
            axios.get('/api/supplier/memberList', {
                params: {
                    supplierId: this.account.supplierId
                }
            }).then(response => {
                if (response.status == 200) {
                    this.myTeamMembers = response.data;
                }
            })
        },
        treasurerChanged() {
            this.payment.treasurerUserAccount = this.account;
        },
        selectedCountryChanged(e) {
            this.reservation.billing.details.country = e.id;
        },
        composePaymentDetailsRow (payment) {
            // CASH | Description (notes) | Person name - If Stripe (type: -90)
            let paymentMethod = this.payMethodIdToName(payment.type);
            let userName;
            let note = payment.description;

            if (payment.treasurerUserAccount && payment.treasurerUserAccount.name) {
                userName = payment.treasurerUserAccount.name;
            } else if (payment.treasurerAgent && payment.treasurerAgent.brandName) {
                userName = payment.treasurerAgent.brandName;
            } else if (payment.treasurerChannel && payment.treasurerChannel.brandName) {
                userName = payment.treasurerChannel.brandName;
            }

            let outputArr = [];

            if (paymentMethod && payment.type != -90 || note == "" || note == null) {
                outputArr.push(paymentMethod);
            }

            if (userName != undefined) {
                outputArr.push(userName);
            }

            if (note) {
                outputArr.push(note);
            }

            return outputArr.join(' | ');
        },
        getPaymentMethodImg(paymentMethod) {
            return '@/assets/images/paymentMethods/Logo_Redunicre.png';
        }
    },
    components: {
        vSelect: extendedVSelect,
        paymentMethodPicker
    }
}
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/_variables.scss';

    .paymentRowsHolder {
        max-height: 200px;
        overflow: auto;

        div:nth-child(odd){
            background-color: $lighter;
        }
    }

    .payMethod{
        width: 103px;
        height: 72px;
        position: relative;

        .payeLabel {
            position: absolute;
            bottom: 7px;
            width: 100%;
        }

        &.selected {
            border-color: $darkest !important;
            border-width: 2px !important;
        }

        &:hover {
            background-color: $lighter;
        }
    }

    .popupBg {
        background-color: rgba(0,0,0,0.5);
        width: 100%;
        height: 100%;
        z-index: 10;
        position: absolute;

        .popupArea {
            width: 800px;
            max-height: 100%;
            margin: 0 auto;
            overflow: auto;

        }
    }
</style>



// WEBPACK FOOTER //
// AddPayment.vue?f867c0dc